import { render } from "./OigusedJaKohustusedLeht.vue?vue&type=template&id=84a4a63a&scoped=true&ts=true"
import script from "./OigusedJaKohustusedLeht.vue?vue&type=script&lang=ts"
export * from "./OigusedJaKohustusedLeht.vue?vue&type=script&lang=ts"

import "./OigusedJaKohustusedLeht.vue?vue&type=style&index=0&id=84a4a63a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a4a63a"]])

export default __exports__